const FormButton = (props) => {

    // TODO: Questo é molto sporco
    return <button onClick={event => props.onClick(event.target.value)} className={props.className}>{props.label}</button>
};

export default FormButton;